import gql from 'graphql-tag';
import {PAGE_SIZE, PAGE_NUMBER, SORT_PARAM} from '../../../utils/constants';
import haWrapper from '../../../utils/haWrapper';
import {sendCustomAnalytics} from '../../../utils/loadTimeAnalyticsWrapper';

export const setQueryStartTimer = (measureName) => {
    haWrapper.userTiming.mark(`${measureName}_start`);
};

export const setQueryEndTimer = (measureName) => {
    haWrapper.userTiming.mark(`${measureName}_end`);
    haWrapper.userTiming.measureAndSend(
        measureName,
        `${measureName}_start`,
        `${measureName}_end`
    );
    sendCustomAnalytics(measureName, 'measure', (analytics) => ({
        [`${measureName}_durationTime`]: {
            value: analytics.duration
        },
        [`${measureName}_startTime`]: {
            value: analytics.startTime
        }
    }));
};

const validateFieldForNull = (field) =>
    typeof field === 'undefined' ? null : field;

const validateFieldForZero = (field) =>
    typeof field === 'undefined' ? 0 : field;

export const clearQueryTimer = (measureName) => {
    haWrapper.userTiming.clearMarks(`${measureName}_start`);
    haWrapper.userTiming.clearMarks(`${measureName}_end`);
    haWrapper.userTiming.clearMeasures(measureName);
};

export const setVariables = (inputParams, systemId, propertyId) => {
    const {
        arrival,
        departure,
        filter,
        adultsCount,
        childrenCount,
        petIncluded,
        minBedrooms,
        maxBedrooms,
        minSleeps,
        maxSleeps,
        minBathrooms,
        maxBathrooms,
        minPrice,
        maxPrice
    } = inputParams;

    return {
        request: {
            propertyId,
            systemId,
            paging: {page: PAGE_NUMBER, pageSize: PAGE_SIZE},
            sort: SORT_PARAM,
            dates:
                arrival && departure
                    ? {
                          arrivalDate: arrival,
                          departureDate: departure
                      }
                    : null,
            filters: filter,
            coreFilters: {
                adults: validateFieldForNull(adultsCount),
                children: validateFieldForNull(childrenCount),
                pets: petIncluded ? 1 : 0,
                minBedrooms: validateFieldForZero(minBedrooms),
                maxBedrooms: validateFieldForNull(maxBedrooms),
                minSleeps: validateFieldForZero(minSleeps),
                maxSleeps: validateFieldForNull(maxSleeps),
                minBathrooms: validateFieldForZero(minBathrooms),
                maxBathrooms: validateFieldForNull(maxBathrooms),
                minPrice:
                    minPrice === 0 ? null : validateFieldForNull(minPrice),
                maxPrice: validateFieldForNull(maxPrice)
            }
        }
    };
};

export const createMultiUnitSearchQuery = (currency) => {
    return gql`
        query multiUnitSearch($request: MultiUnitSearchRequest!) {
            multiUnitSearch(request: $request) {
                resultCount
                listings {
                    petsAllowed
                    instantBookable
                    mobileThumbnailUrl
                    bedrooms
                    unitName
                    sleeps
                    propertyMetadata {
                        headline
                    }
                    propertyType
                    bathrooms {
                        full
                        half
                        toiletOnly
                    }
                    spaces {
                        bedrooms {
                            capacity
                            name
                            note
                            type
                        }
                        spacesSummary {
                            area {
                                areaValue
                            }
                        }
                    }
                    averageRating
                    reviewCount
                    averagePrice {
                        currencyUnits
                        periodType
                        value
                    }
                    detailPageUrl
                    priceSummary(currency: "${currency}") {
                        pricePeriodDescription
                        formattedAmount
                        edapEventJson
                    }
                    totalPrice {
                        currencyUnits
                        periodType
                        value
                    }
                    listingId
                }
            }
        }
    `;
};
